// 商城自定义模块(通用)
import {

  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,
  WgtAbtest,

  WgtStickyLift,
  WgtTabsCut,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtProductShelves,
  WgtImageText,
  WgtArticle,
  WgtMemberInfo,
  WgtSuspension,
  WgtOfficialAccount,
  WgtNewMemberInfo,
  wgtDevices
  // WgtContentPart
} from '../wgts/index'

export const initiWidgets = []

export const widgets = {

  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,
  WgtAbtest,

  WgtStickyLift,
  WgtTabsCut,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtProductShelves,
  WgtImageText,
  WgtArticle,
  WgtMemberInfo,
  WgtSuspension,
  WgtOfficialAccount,
  WgtNewMemberInfo,
  wgtDevices
  // WgtUserContainer
  // WgtContentPart
}


export default {
  widgets,
  initiWidgets
}
